import { QueryFilter, SortState } from '@fox/data-grid';

export const FILTER_MIN_WIDTH = '300px';
export type SwiftFoxActionCentreResult = {
	data: Record<string, string>[];
	totalResults: number;
};

export type SwiftFoxActionCentreColumnsResult = {
	columns: ActionCentreColumn[];
	name: string;
};

export type ActionCentreColumn = {
	id: string;
	title: string;
	type: string; //i.e custom
	filterType: string;
	sortIndex?: string;
	filterGroup?: string;
	filterable?: boolean;
	customFieldMetadata?: string;
};

export type ActionCentreDataInputModel = {
	contentId: string;
	id: string;
	page?: number;
	pageSize?: number;
	sourceFilter?: string;
	sort?: SortState;
	filters?: QueryFilter[];
};

export interface IActionCentreTableProps {
	actionId: string;
	rowsExpandedOnSmallScreens: boolean;
	disableExport?: boolean;
	filterPositioning?: 'Top' | 'Left' | undefined;
	rowsPerPage?: number;
}

export interface IActionCentreViewProps {
	filter: string;
	actionId: string;
	columnsResult: SwiftFoxActionCentreColumnsResult;
	sourceOptions: [string, string][];
	setSourceFilter: (value: string) => void;
	showFilters: boolean;
	enableClearFilters: boolean;
	setPage: React.Dispatch<React.SetStateAction<number>>;
	setFilters: React.Dispatch<React.SetStateAction<QueryFilter[]>>;
	filters: QueryFilter[];
	updateFilters: (value: string | undefined, column?: ActionCentreColumn) => void;
	setSort: React.Dispatch<React.SetStateAction<SortState>>;
	disableExport: boolean;
	pageSize: number;
	page: number;
	showSearch: boolean;
	rowsExpandedOnSmallScreens: boolean;
	sort?: SortState;
}
